module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex student"
  }, [_c('div', {
    staticClass: "basic"
  }, [_c('student-profile', {
    attrs: {
      "student": _vm.student,
      "edit_id": _vm.edit_id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-AddBox"
  }, [_c('student-tutors-index', {
    attrs: {
      "student": _vm.student
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-support"
  }, [_c('student-history', {
    attrs: {
      "student": _vm.student,
      "condition": _vm.condition,
      "edit_id": _vm.edit_id,
      "type": "true"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c5f722f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Student/StudentIndex.vue
// module id = 1386
// module chunks = 0